import React from 'react'

import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { appUpdateRequest } from '../../actions'
import { Prompt } from 'react-router-dom'

import { Box, Row, Column } from 'components/Layout'
import { Form, FormSection, FormError } from 'components/Form'
import { SaveButton, Button } from 'components/Button'
import { BoxShell } from 'components/Shells'
import { Image } from 'components/Image'

import { AppIsPendingReviewBanner } from '../../views/Banners'
import {
	extensionUrlValidator
	// extensionLogoUrlValidator
} from './validators.js'
import FieldSection from './FieldSection.js'
import { TEXT, HIDDEN } from './fieldTypes.js'

// import AgentAppExtension from '../../assets/intros/agent-app-extension.svg'
import agentAppExtension from '../../assets/intros/agent-app-extension.png'

const AppFeaturesAgentAppExtensionForm = props => {
	const {
		dispatchSubmit,
		handleSubmit,
		submitting,
		dirty,
		app,
		change,
		error,
		readOnly,
		inReview
	} = props

	const prepopulate = url => {
		change('customData.url', url)
	}

	const fields = [
		{
			type: TEXT,
			name: 'customData.url',
			fieldId: 'customData.url',
			title: 'Extension source URL',
			description: (
				<div>
					A URL to the extension content. Make sure to provide
					SSL-enabled address. Don't have the code yet? Grab an
					example:{' '}
					<a
						href="#"
						onClick={e => {
							e.preventDefault()
							prepopulate('https://data-dashboard.glitch.me/')
						}}
					>
						Google Spreadsheet Loader
					</a>.
				</div>
			),
			placeholder: 'https://www.your.com/extension.js',
			validate: extensionUrlValidator,
			required: true,
			disabled: readOnly
		},
		{
			type: HIDDEN,
			name: 'customData.placement',
			fieldId: 'customData.placement',
			title: 'Plugin placement',
			description:
				"We currently support only one extension placement: sidebar at the right-hand side. If you'd like us to prepare more possible placements, let us know!",
			// placeholder: 'sidebar',
			value: 'sidebar',
			required: false,
			disabled: true
		}
	]

	if (typeof app === 'undefined') {
		return (
			<Form>
				<BoxShell height={200} />
				<BoxShell height={140} />
			</Form>
		)
	}

	return (
		<Form handleSubmit={handleSubmit(dispatchSubmit)}>
			<Prompt
				when={submitting || dirty}
				message={() =>
					`You've got unsaved changes. Are you sure you want to leave this page?`
				}
			/>

			<AppIsPendingReviewBanner appId={app.id} inReview={inReview} />

			<Box
				header={'Agent App Extension'}
				body={
					<span>
						<FormSection dark>
							<Row notPadded center>
								<Column width={3}>
									<Image
										src={agentAppExtension}
										height={200}
										style={{ margin: '0 auto' }}
									/>
								</Column>
								<Column>
									<p>
										<strong>Agent App Extensions</strong>{' '}
										are web applications loaded inside the
										chat.io Agent App.
									</p>
									<a
										href={
											process.env.REACT_APP_DEV_DOCS_URL +
											'/agent-app-extension'
										}
										target="_blank"
										rel="noopener"
									>
										<Button type={'ghost'}>
											Learn more
										</Button>
									</a>
								</Column>
							</Row>
						</FormSection>
						<div>
							{fields.map(field => {
								return (
									<FieldSection
										{...field}
										key={field.fieldId}
									/>
								)
							})}
						</div>
					</span>
				}
				info={
					!readOnly ? (
						<span>
							{!submitting ? <FormError error={error} /> : null}
							<SaveButton submitting={submitting} dirty={dirty} />
						</span>
					) : (
						<span>App in review – read only</span>
					)
				}
			/>
		</Form>
	)
}

const mapStateToProps = (state, ownProps) => {
	const currentApp = state.apps.items[ownProps.match.params.appId]
	const readOnly = currentApp ? currentApp.status !== 'IN_DEVELOPMENT' : false
	const inReview = currentApp ? currentApp.status === 'IN_REVIEW' : false

	if (currentApp && currentApp.customData) {
		currentApp.customData.placement = 'sidebar'
	}

	return {
		app: currentApp,
		readOnly,
		inReview,
		initialValues: currentApp || {
			customData: {}
		}
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		dispatchSubmit: values => {
			dispatch(
				appUpdateRequest({
					formName: 'appFeaturesAgentAppExtension',
					...values
				})
			)
		}
	}
}

const ConnectedAppFeaturesAgentAppExtensionForm = connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: 'appFeaturesAgentAppExtension',
		touchOnBlur: false,
		enableReinitialize: true
	})(AppFeaturesAgentAppExtensionForm)
)

export default ConnectedAppFeaturesAgentAppExtensionForm



// WEBPACK FOOTER //
// ./src/containers/Forms/AppFeaturesAgentAppExtensionForm.js